/* eslint-disable no-console */
import isSvg from 'is-svg';
import { jsPDF } from 'jspdf';

import { SlideElementSvgType } from '../../components/SlideComponents/slide.types';
import { replacefigureColors } from '../../components/SlideComponents/slideUtil';
import backendService from '../../services/backendService';
import { SVG_IMAGE_ZOOM } from './constants';

const drawSvg = async (svgValue: string, canvas: HTMLCanvasElement): Promise<string> => {
  return new Promise((resolve, reject) => {
    const svg64 = Buffer.from(svgValue);
    const b64Start = 'data:image/svg+xml;base64,';
    const image64 = `${b64Start}${svg64.toString('base64')}`;
    const img = new Image();
    img.onload = () => {
      const scale_factor = Math.min(canvas.width / img.width, canvas.height / img.height);
      const newWidth = img.width * scale_factor;
      const newHeight = img.height * scale_factor;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject('Unable to create a context');
        return;
      }
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      resolve(canvas.toDataURL());
    };
    img.onerror = reject;
    img.src = image64;
  });
};

export const addSvgElement = async (
  pdf: jsPDF,
  element: string,
  x: number,
  y: number,
  width: number,
  height: number,
) => {
  const canvas = document.createElement('canvas');
  canvas.width = width * SVG_IMAGE_ZOOM;
  canvas.height = height * SVG_IMAGE_ZOOM;

  const isElementSvgBlob = isSvg(element);
  let svgBlob = element;

  if (!isElementSvgBlob) {
    const response = await fetch(element);
    svgBlob = await response.text();
  }

  const image = await drawSvg(svgBlob, canvas);
  pdf.addImage(image, x, y, width, height, undefined, 'FAST');
};

export const addSvgMedia = async (pdf: jsPDF, element: SlideElementSvgType) => {
  const { x, y, width, height, borderRadius, mediaFileId, colors } = element;
  const svgTextData = await backendService.instance.gameFiles.fetchSvgImage({
    fileId: mediaFileId ?? '',
    isOwner: true,
    isFromDiscover: false,
    isAuthenticated: true,
  });

  if (!svgTextData) {
    console.error('Image could not be loaded');
    return;
  }

  const svgText = replacefigureColors(svgTextData, colors);

  pdf.saveGraphicsState();
  try {
    const radiusWidth = width * ((borderRadius ?? 0) / 100);
    const radiusHeight = height * ((borderRadius ?? 0) / 100);
    pdf.roundedRect(x, y, width, height, radiusWidth, radiusHeight, null);
    pdf.clip();
    pdf.discardPath();
    await addSvgElement(pdf, svgText, x, y, width, height);
  } catch (err) {
    console.error('Image could not be added');
    console.error(err);
  }
  pdf.restoreGraphicsState();
};

export const addSvg = async (pdf: jsPDF, element: SlideElementSvgType) => {
  const { svgValue = '', x, y, width, height, mediaFileId } = element;
  if (mediaFileId) {
    await addSvgMedia(pdf, element);
  } else {
    await addSvgElement(pdf, svgValue, x, y, width, height);
  }
};
